import { render, staticRenderFns } from "./OverrideCopyDialog.vue?vue&type=template&id=6dcb7efc&"
import script from "./OverrideCopyDialog.vue?vue&type=script&lang=js&"
export * from "./OverrideCopyDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports